import { useQuery } from '@tanstack/react-query';
import { rpcClient } from 'src/api/rpc/client';

export function useListPendingApprovals(options?: {
  limit?: number;
  offset?: number;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: [
      'workflow-approvals',
      options?.limit ?? 50,
      options?.offset ?? 0,
    ],
    queryFn: () =>
      rpcClient.workflows.listPendingApprovals({
        limit: options?.limit ?? 50,
        offset: options?.offset ?? 0,
      }),
    refetchInterval: 15_000,
    enabled: options?.enabled ?? true,
  });
}
